import { render, staticRenderFns } from "./DrawImage.vue?vue&type=template&id=38431c66&scoped=true"
import script from "./DrawImage.vue?vue&type=script&lang=js"
export * from "./DrawImage.vue?vue&type=script&lang=js"
import style0 from "./DrawImage.vue?vue&type=style&index=0&id=38431c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38431c66",
  null
  
)

export default component.exports